var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hp-section"},[(_vm.newsItems.length > 0)?_c('news-carousel',{attrs:{"news-link":_vm.newsLink,"news-items":_vm.newsItems}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }